import React from 'react'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useSetActiveModal } from 'src/Modal/ModalStateContext'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { Changelog, useInfoPanelContext } from '../../../../InfoPanel'
import { ModalFormId } from '../../../../components/ModalForms'
import { generatePermalinkFromId } from '../../../../components/PageLayout/Permalink'
import { useInAudit } from '../../../../context/AuditContext'
import { useCurrentControl } from '../../../../context/FormContext'
import { useRemoveControlFromRequestModal } from '../../../../Modal/useRemoveControlFromRequestModal'

export const ViewDetails = (): JSX.Element => {
  const {
    currentControl: { modelId },
  } = useCurrentControl()
  const navigate = useNavigate()
  const params = useParams()
  const onViewDetails = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()

      navigate(
        generatePermalinkFromId({
          pageContext: params.pageContext as string,
          modelId,
          modelType: MODEL_TYPE.CONTROL,
          isInternalLink: true,
        }),
      )
    },
    [modelId, navigate, params.pageContext],
  )

  return (
    <BasicDropdownMenuItem eventKey="1" onClick={onViewDetails}>
      View Details
    </BasicDropdownMenuItem>
  )
}

export const InScopeItems = (): JSX.Element => {
  const openAddEvidenceModal = useSetActiveModal(ModalFormId.ADD_EVIDENCE)

  return (
    <>
      <BasicDropdownMenuItem
        eventKey="2"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          openAddEvidenceModal()
        }}
      >
        Add Evidence
      </BasicDropdownMenuItem>
      <Dropdown.Divider />
    </>
  )
}

export const RemoveControlFromAudit = (): JSX.Element => {
  const { removeControl } = useCurrentControl()

  return (
    <BasicDropdownMenuItem
      eventKey="4"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        removeControl()
      }}
    >
      Remove from this Audit
    </BasicDropdownMenuItem>
  )
}

export const DeleteControl = (): JSX.Element => {
  const { auditId } = useInAudit()
  const { deleteControl } = useCurrentControl()

  return (
    <>
      {auditId && <RemoveControlFromAudit />}
      <BasicDropdownMenuItem
        eventKey="5"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          deleteControl()
        }}
      >
        Delete Control
      </BasicDropdownMenuItem>
    </>
  )
}

export const CopyLink = (): JSX.Element => {
  const params = useParams()
  const {
    currentControl: { id: controlId },
  } = useCurrentControl()
  const onCopyLink = useCallback(
    async (e: React.MouseEvent) => {
      e.preventDefault()
      await navigator.clipboard.writeText(
        generatePermalinkFromId({
          pageContext: params.pageContext as string,
          modelId: controlId,
          modelType: MODEL_TYPE.CONTROL,
          isInternalLink: false,
        }),
      )
    },
    [controlId, params.pageContext],
  )
  return (
    <BasicDropdownMenuItem eventKey="6" onClick={onCopyLink}>
      Copy Permalink
    </BasicDropdownMenuItem>
  )
}

export const ViewActivities = (): JSX.Element => {
  const { setInfoPanelState } = useInfoPanelContext()
  const {
    currentControl: { id: controlId },
  } = useCurrentControl()

  const onViewActivities = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      setInfoPanelState({
        isShown: true,
        render: <Changelog subjectIds={[controlId]} />,
      })
    },
    [controlId, setInfoPanelState],
  )

  return (
    <BasicDropdownMenuItem eventKey="7" onClick={onViewActivities}>
      View Activities
    </BasicDropdownMenuItem>
  )
}

export const RemoveControl = ({
  requestId,
}: {
  requestId: string
}): JSX.Element => {
  const removeControl = useRemoveControlFromRequestModal({ requestId })
  return (
    <BasicDropdownMenuItem
      eventKey="8"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        removeControl()
      }}
    >
      Remove Control
    </BasicDropdownMenuItem>
  )
}
